

































import Vue, { PropType } from "vue";
import Date from "@/lib/convertDate";
import Locale from "@/lib/locale";

export interface CloudContractsPlanNamesProps {
  lang: any;
  oldPlanTranslatedName: string;
  newPlanTranslatedName: string;
  newPlanApplyAt: number;
}

export interface CloudContractsPlanNamesData {
  locale: string;
}

export default Vue.extend({
  name: "vc-cloud-contracts-change-plan-names",

  data(): CloudContractsPlanNamesData {
    return {
      locale: Locale.getLocale()
    };
  },

  props: {
    lang: {
      type: Object as PropType<CloudContractsPlanNamesProps["lang"]>,
      default: () => {}
    },
    oldPlanTranslatedName: {
      type: String as PropType<
        CloudContractsPlanNamesProps["oldPlanTranslatedName"]
      >,
      default: ""
    },
    newPlanTranslatedName: {
      type: String as PropType<
        CloudContractsPlanNamesProps["newPlanTranslatedName"]
      >,
      default: ""
    },
    newPlanApplyAt: {
      type: Number as PropType<CloudContractsPlanNamesProps["newPlanApplyAt"]>,
      default: 0
    }
  },

  computed: {
    newPlanApplyAtText(): string {
      if (!this.newPlanApplyAt) return "";
      return this.lang.about_change_plans.new_plan_apply_date_step.replace(
        ":date",
        Date.getDate(this.newPlanApplyAt, this.locale, "yyyy/M/d")
      );
    }
  }
});
